module.exports = __webpack_public_path__ + "img/FR17206.754c75ab.png";